import { useEffect } from 'react';
import { useEntityList } from '@backstage/plugin-catalog-react';
import {
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

interface CustomFilters {
  kind?: any;
  industryFilter?: EntityIndustryFilter;
}

// EntityIndustryFilter for filtering by spec.industry
export class EntityIndustryFilter implements EntityFilter {
  readonly values: string[];

  constructor(values: string[]) {
    this.values = values;
  }

  getCatalogFilters(): Record<string, string | string[]> {
    return { 'spec.industry': this.values };
  }

  filterEntity(entity: Entity): boolean {
    const entityIndustry = entity.spec?.industry as string | undefined;
    return entityIndustry !== undefined && this.values.includes(entityIndustry);
  }

  toQueryValue(): string[] {
    return this.values;
  }
}

export const ProjectIndustryPicker = () => {
  const {
    filters: { kind, industryFilter },
    updateFilters,
  } = useEntityList<CustomFilters>();

  const currentKind = String(kind?.value ?? '').toLowerCase();
  const isProject = currentKind === 'project';

  useEffect(() => {
    if (!isProject && industryFilter) {
      updateFilters({ industryFilter: undefined });
    }
  }, [isProject, industryFilter, updateFilters]);

  if (!isProject) {
    return null;
  }

  return (
    <EntityAutocompletePicker
      label="Industry"
      name={'industry' as any}
      path="spec.industry"
      Filter={EntityIndustryFilter}
      showCounts
    />
  );
};
